//@ts-nocheck
"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const useGAPageView = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = pathname + (searchParams?.toString() ? `?${searchParams}` : "");

    if (typeof window.gtag === "function") {
      window.gtag("config", "G-Z66XJQ8BHQ", {
        page_path: url,
      });
    }
  }, [pathname, searchParams]);
};

export default useGAPageView;
